import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import MetaTags from 'react-meta-tags';
import Home from './pages/Home';
import Play from './pages/Play';
import Stats from './pages/Stats';
import Subjects from './pages/Subjects';
import InvitePage from './pages/InvitePage';
import Dashboard from './pages/Dashboard';
import Invitation from './pages/Invitation';
import CreateLoginPage from './pages/CreateLoginPage';
import ProfilePage from './pages/ProfilePage'
import AdminDashboard from './pages/AdminDashboard';
import NoMatch from './pages/404';

function App() {
  return (
    <div className="app">
      <MetaTags>
        <link rel="preload" href="/Chango Regular.ttf" as="font" crossOrigin/>
      </MetaTags>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home/>}/>
          <Route path="/new/:subjectId" element={<Play />} />
          <Route path="/newlogin" element={<CreateLoginPage />} />
          <Route path="/play/:groupGuid" element={<Play />} />
          {/*<Route path="/score" backUrl={backUrl} element={<Score />} />*/}
          <Route path="/stats/:groupGuid" element={<Stats />} />
          <Route path="/subjects" element={<Subjects />} />
          <Route path="/invitation/:playerFromId/:groupGuid" element={<Invitation />} />
          <Route path="/invite/:groupGuid/:subject" element={<InvitePage />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/jn6-we_ed.f68aefj3" element={<AdminDashboard />} />
          <Route path="*" element={<NoMatch/>}/>
        </Routes>
      </BrowserRouter>
    </div>
  )
}

export default App;
